import google, { mutators, noPrintClass, removeMapControl, repositionMapControl, verify } from "@churchofjesuschrist/maps-google";
import { buttonClass, classNames, controlClass, proxy, removeUndefined, styleClass } from "@churchofjesuschrist/maps-utils";
import { add, minus, toHTMLString } from "@churchofjesuschrist/eden-icons-raw";
import MapsService from "@churchofjesuschrist/maps-service";
let initialized = false;
const defaultOptions = {};
class ZoomControl {
  constructor(options = {}) {
    if (!initialized) {
      verify();
      construct();
      initialized = true;
    }
    this.setOptions({
      ...defaultOptions,
      ...removeUndefined(options)
    });
  }
}
const construct = () => {
  Object.assign(defaultOptions, {
    position: google.maps.ControlPosition.RIGHT_BOTTOM
  });
  const canvasClass = styleClass("google-zoom", null, controlClass())`
        width: 2.5rem;
    `;
  const stackedButtonClass = styleClass("google-zoom", "button", buttonClass())`
        &:first-child {
            border-bottom-color: transparent;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
        &:nth-child(2) {
            border-top-color: transparent;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
    `;
  const stringsPromise = MapsService.getStrings(["zoom.zoomin", "zoom.zoomout"]);
  Object.setPrototypeOf(ZoomControl.prototype, Object.assign(new google.maps.MVCObject(), mutators("map"), (() => {
    function onAdd() {
      let map = this.getMap();
      if (this.$map !== map) {
        onRemove.call(this);
        this.$map = map;
        if (!this.$div) {
          this.$div = document.createElement("div");
          let zoomIn = createButton(add);
          zoomIn.addEventListener("click", proxy(onZoomIn, this));
          this.$div.appendChild(zoomIn);
          let zoomOut = createButton(minus);
          zoomOut.addEventListener("click", proxy(onZoomOut, this));
          this.$div.appendChild(zoomOut);
          stringsPromise.then(strings => {
            zoomIn.title = strings["zoom.zoomin"];
            zoomOut.title = strings["zoom.zoomout"];
          });
        }
        updateClassName.call(this);
        updatePosition.call(this);
      }
    }
    function onRemove() {
      removeMapControl(this.$map, this.$div);
      delete this.$map;
    }
    function updatePosition() {
      let position = this.get("position");
      repositionMapControl(this.getMap(), this.$div, position);
    }
    function updateClassName() {
      if (this.$div) {
        let className = this.get("className");
        this.$div.className = classNames(className, canvasClass, noPrintClass);
      }
    }
    function createButton(icon) {
      let button = document.createElement("button");
      button.type = "button";
      button.className = stackedButtonClass;
      button.innerHTML = toHTMLString(icon);
      return button;
    }
    function zoomMap(value) {
      let map = this.getMap();
      if (map) {
        let zoom = map.getZoom();
        map.setZoom(zoom + value);
      }
    }
    function onZoomIn() {
      zoomMap.call(this, 1);
    }
    function onZoomOut() {
      zoomMap.call(this, -1);
    }
    return {
      getDiv: function () {
        return this.$div;
      },
      changed: function (key) {
        switch (key) {
          case "map":
            if (this.getMap()) {
              onAdd.call(this);
            } else {
              onRemove.call(this);
            }
            break;
          case "position":
            updatePosition.call(this);
            break;
          case "className":
            updateClassName.call(this);
            break;
        }
      }
    };
  })()));
};
export default ZoomControl;